<template>
  <div>
    <div class="login login_1st">
      <div class="login-wrap">
        <div class="login_id-pass">
          <div class="login_input-box login">
            <p class="login_cont-name">ログインＩＤ</p>
            <input
              type="text"
              id="name"
              name="ログインID"
              required=""
              minlength="4"
              maxlength="8"
              size="10"
              placeholder="EXAMPLE_ID"
              v-model="loginid"
            />
            <p class="login_cont-name">パスワード</p>
            <div class="login_pass-box">
              <input
                id="password"
                name="パスワード"
                required=""
                v-model="password"
                :type="pwdFlag ? 'password' : 'text'"
              />
              <button class="btn_passview">
                <img
                  src="@/assets/img/login/pass.png"
                  :class="[this.pwdFlag ? '' : 'img-opacity']"
                  @click="changePwd"
                  alt="非表示"
                />
              </button>
            </div>

            <p class="login_pass-lose">
              パスワードを忘れた方は
              <a @click="openForgotPwd" href="javascript:;">こちら</a>
            </p>
          </div>
          <van-button
            :disabled="this.loginid === '' || this.password === ''"
            block
            :color="
              this.loginid === '' || this.password === ''? '#AACBE7': '#3B82C4'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="onClickLogin"
            id="login1_btn"
            >ログイン</van-button>
        </div>
      </div>
    </div>
    <div id="privacy-policy" v-show="privacyPolicyShow">
      <div class="privacy_inner">
        <div class="privacy_content">
          <p class="privacy_title">利用規約</p>
          <p class="indent">
            イツモスマイル株式会社(以下「当社」という)は、以下のサービス利用規約(以下「本規約」という)に基づき、ビデオ通話アプリ 「QuaLink」サービス(以下「本サービス」という)をユーザの皆様へご提供いたします。なお、本規約における「ユーザ」とは、本サービスの申込をし、当社からIDの発行を受けた法人又は個人、並びにその法人又は個人から招待されるなどして本サービスを利用又は本ソフトウェアをインストールする方を意味します。また、「本契約」とは本規約に基づく本サービスの利用契約を意味します。
          </p>
          <p class="indent">
            ユーザの皆様は、本サービスにログインし、本サービスの機能の一部を利用するために必要となるソフトウェアをインストールもしくはご利用いただくことによって、本規約の内容を承諾したものとみなされます。​
          </p>
          <p class="privacy_content-name">1. 本サービスの内容</p>
          <p class="indent">
            本サービスの内容は、「QuaLink」の公式ホームページ(https://qualink.jp)上に掲載されております。
          </p>
          <p class="privacy_content-name">2. 本サービスのバージョンアップ</p>
          <p class="indent">
            当社はユーザの皆様に、契約済みのサービスに関しては常に無償にて本サービスの最新バージョンを提供いたします。
          </p>
          <p class="privacy_content-name">3. 本サービス内容の変更</p>
          <p class="indent">
            当社が必要と判断した場合には、ユーザの皆様に通知することなく、いつでも本サービスの内容を変更することができるものとします。
          </p>
          <p class="indent">
            当社は、上記変更によるユーザ様への責任は負わないものとします。
          </p>
          <p class="privacy_content-name">4. URLの変更等</p>
          <p class="indent">
            当社は、本サービスのURL並びにコンテンツの内容を予告なく変更することがあります。
          </p>
          <p class="indent">
            当社は、上記変更によるユーザ様への責任は負わないものとします。
          </p>
          <p class="privacy_content-name">5. 本サービスの利用について</p>
          <p class="indent">
            (1)　ユーザの皆様は、PC及びその他の対応端末よりインターネットにアクセスしていただくことによって本サービスを利用できます。対応端末とは、当社が検証を行い動作確認済の端末をいいます。対応端末については、当社が予告なく変更する場合があります。ユーザの皆様の責任と費用で、必要なPC、その他対応端末、機器やソフトウェア、通信手段等をご用意いただき、それらを適切に設置、設定、操作いただく必要があります。本サービスをご利用になる際、ユーザ様のご使用になるPC及びその他対応端末本体、周辺機器、PC及びその他対応端末にインストールされたプログラム、通信回線及びそれらのものから受ける影響によって発生する本サービスへの障害、各種トラブルについて、当社は責任を負いません。
          </p>
          <p class="indent"> 
            (2)　本サービスのご利用は、ユーザ様ご自身の責任において行うものとします。本サービスを利用してダウンロード等の方法で入手するすべてのものは、ダウンロード等を行うことを含めてユーザ様ご自身の責任上で行うものとします。これらの行為の結果生じる損害については、ユーザ様の責任となります。ユーザ様が当社及び代理店から直接又は本サービスを通じてアドバイスや情報を得た場合であっても、当社及び代理店は本規約に規定されている内容を超えて保証を行うものではありません。なお、当該アドバイス等は限られた情報に基づいて行われるものであり、当該アドバイス等についてもその内容の真偽、適格性、正確性について保証するものではありません。
          </p>
          <p class="indent">
            (3)　ユーザの皆様は、本サービスがデータを送受信する過程で、種々のネットワークを経由することをご理解ください。よって、接続しているネットワークや機器、機材によっては、それらの接続や、それらを通過するために必要なデータ、信号等の変更がなされる可能性があることを承諾した上で、本サービスをご利用いただくものとします。
          </p>
          <p class="privacy_content-name">6. ユーザ登録</p>
          <p class="indent">
            本サービスをご利用いただくにあたり事前にユーザ登録が必要です。ユーザ登録は、申込後、ユーザ様から申告頂く登録データを基に当社で行います。
          </p>
          <p class="indent">
            本サービスのご利用については次の条件をお守りください。ユーザ登録には、ユーザ様ご自身に関する真実かつ正確な情報で、要求されるすべての項目を登録していただきます。この登録データが常に真実かつ正確な内容であるように必要に応じて随時修正していただきます。万一上記に違反した場合、又は真実かつ正確なデータが提供されていないと当社が判断した場合には、当該ユーザIDを削除し、本サービスのご利用をお断りすることがあります。
          </p>
          <p class="privacy_content-name">7. ID・パスワードの管理</p>
          <p class="indent">
            ID・パスワードの登録並びにその管理は、ユーザ様の責任において行うものとします。ID並びにパスワードを利用して行われた行為の責任は、当該IDを保有しているユーザ様の責任とみなします。パスワードの漏洩、不正使用などから生じた損害について、当社は一切補償いたしません。
          </p>
          <p class="privacy_content-name">8. 本サービスの有効期間</p>
          <p class="indent">
            (1)　本サービスの有効期間は、本サービスのID・パスワードがユーザ様に到達した日(以下「納入日」という)に開始し、本サービスのプランに応じて設定される本契約の有効期間満了日に終了するものとします。
          </p>
          <p class="indent">
            (2)　ユーザの皆様は、①月間契約、②暦月単位の複数月で当社と別途合意する複数月契約(年間契約を含む)、③当社と別途合意する期間とするスポット契約(①②③の契約期間を以下「本期間」という)のいずれかを、申込の際に選択することができます。本期間の満了日は、月間契約にあたっては納入日が属する月(以下「利用開始月」という)の翌月末日、複数月契約にあたっては、利用開始月の翌月から起算して本期間が満了する月の月末日、スポット契約にあたっては本期間の最終日とします。
          </p>
          <p class="indent">
            (3)　本期間の満了日の2ヶ月前までにユーザ様から書面による解約の通知が当社又は代理店に到達しない場合、本期間は、月間契約にあたっては1ヶ月間、複数月契約にあたっては更新前の本期間と同一の期間、同内容で自動的に更新され、以降も同様とします。
          </p>
          <p class="privacy_content-name">9. 本サービスの利用料金</p>
          <p class="indent">
            本サービスをご利用いただくにあたり、当社または代理店はユーザ様より利用料金を申し受けます。利用料金は当社または代理店から提示された支払い条件に基づき支払うものとします。ユーザの皆様が本サービスを利用する目的で支払われた利用料金は、本規約で明示的に規定する場合を除き、払い戻しは行わないものとします。
          </p>
          <p class="privacy_content-name">10. コンテンツ、データ等の帰属</p>
          <p class="indent">
            (1)　ユーザの皆様が送信したものを除き、本サービスに含まれているコンテンツ、個々の情報(データ)及び情報(データ)の集合体に関する財産権は当社及び当社に当該コンテンツ等を提供している提携先に帰属しています。
          </p>
          <p class="indent">
            (2)　本サービス及び本サービスに関連して使用されているすべてのソフトウェア(以下「ソフトウェア」という)は、 知的財産権に関する法令等により保護されている財産権及び営業秘密を包含しています。本サービスに提供されているソフトウェア及びコンテンツは、著作権法、商標法、意匠法等により保護されています。 
          </p>
          <p class="indent">
            (3)　ユーザの皆様は、当社から、事前の文書による承諾を受けた場合を除いて、本サービス、もしくはソフトウェア、又はそれらに包含される内容(一部あるいは全部を問わず)を複製、削除、公開、送信、頒布、譲渡、貸与、翻訳、翻案、他への使用許諾、転載、再利用しないことに同意するものとします。ユーザ様が本条項に違反した場合には、当該コンテンツ、個々の情報(データ)、情報(データ)の集合体、ソフトウェア及びそれらを複製、公開、送信、頒布、譲渡、貸与、翻訳、翻案、使用許諾、転載、再利用物の利用を当社が差止る権利、並びに当該行為によってユーザ様が得た利益相当額を、当社が請求することができる権利を有します。その際、当社は本サービス製品の購入代金の100倍に相当する金額を利益相当額とみなすことができ、当該ユーザはこれに対し異議を述べることができないものとします。
          </p>
          <p class="privacy_content-name">11. 登録ユーザの利用範囲</p>
          <p class="indent">
            ユーザの皆様は当社が提供するソフトウェアの内容を一度に一台のコンピュータ及びその他対応端末上で実行することができる一身専属的な権利を有します。ただし、ユーザ様がソフトウェアを複写、修正、改変、二次利用したり、リバースエンジニアリング、逆アセンブルなどの方法でソースコードを解読したり、譲渡、再実施許諾したりすることは禁止されています。もし、上記不正行為が行われた場合、当社は、当該行為を差止め請求できるほか、前記と同様の方法で利益相当額の賠償を求めることができます。
          </p>
          <p class="privacy_content-name">12. 登録ユーザの禁止行為</p>
          <p class="indent">
            ユーザの皆様の以下の行為(不正利用)を禁止いたします。
          </p>
          <p>         
            ○法令に違反する行為 <br>
            ○他人の権利を侵害する行為 <br>
            ○他人に経済的・精神的損害を与える行為 <br>
            ○脅迫的な行為 <br>
            ○他人の名誉を毀損する行為 <br>
            ○他人のプライバシーを侵害する行為 <br>
            ○いやがらせ、他人を中傷する行為 <br>
            ○猥褻・猥雑な行為 <br>
            ○品性を欠く行為 <br>
            ○罵詈雑言に類する行為 <br>
            ○嫌悪感を与える行為 <br>
            ○民族的・人種的差別につながる行為 <br>
            ○倫理的観点などから問題のあるサービスを通じて他人に掲載、開示、提供又は送付する行為 <br>
            ○未成年者を害するような行為 <br>
            ○自分以外の人物を名乗ったりする行為 <br>
            ○コンピュータ及びその他の対応端末のソフトウェア、ハードウェア、本サービスを運用するサーバ、通信回線、通信機器の機能を妨害、破壊、制限するようにデザインされたコンピュータウィルス、コンピュータコード、ファイル、プログラムを含むコンテンツをアップロードしたり掲示したり、メールなどの方法で送信(発信)する行為 <br>
            ○画面上での参加者の対話を妨害し、方法の如何を問わず他のユーザが接続・表示、操作、入力しようとすることに悪影響をおよぼすような行為 <br>
            ○本サービス又は本サービスに接続しているサーバもしくはネットワークを妨害したり、混乱させたりする行為 <br>
            ○本サービスに接続しているネットワークの使用条件、操作手順、諸規約、規定に従わない行為 <br>
            ○故意、過失を問わず法令に違背する行為 <br>
            ○ストーカー行為など、方法のいかんを問わず第三者に対する嫌がらせ行為 <br>
            ○他のユーザの個人情報を不当に収集し蓄積する行為 <br>
            ○その他当社が不適切と判断する行為
          </p>
          <p class="privacy_content-name">13. 国際間での利用に関するご注意</p>
          <p class="indent">
            ユーザの皆様は、インターネットをご利用するにあたり、オンライン上でどのような行為やどのような内容のコンテンツが許されるかという点について考慮し、利用される国、地域における規制を遵守しなければなりません。とくに、居住されている国から技術的な情報を他国に向けて送信(発信)される場合には、諸法令を遵守することに細心の注意を払うものとします。
          </p>
          <p class="privacy_content-name">14. トラブルの責任</p>
          <p class="indent">
            ユーザの皆様が本サービスをご利用中に送受信したデータによって発生したユーザ相互間又はユーザと第三者との間のトラブルについては、ユーザ様の費用と責任で解決するものとします。また、上記トラブルに関連して、当社及び代理店に費用、損害が発生した場合、ユーザ様は当該費用等(当社及び代理店が支払った弁護士費用を含む)の求償ないし賠償に応じるものとします。
          </p>
          <p class="privacy_content-name">15. 本サービスの転売、転用の禁止</p>
          <p class="indent">
            当社又はその提携先との正式な契約がある場合を除き、ユーザ様が、商業目的やその他、使用、再生、複製、複写、販売、再販売などの形態の如何を問わず本サービスを第三者に転売、転用することを禁止いたします。
          </p>
          <p class="privacy_content-name">16. データの削除等</p>
          <p class="indent">
            (1)　当社は、事前に本サービスで送受信されるデータを検閲することはいたしませんが、必要と判断した場合には、事後に当該データを削除し、又は掲載場所を変更することができるものとします。また、当社は、本規約に違反するデータ及び当社で問題があると判断したデータを削除することができるものとします。
          </p>
          <p class="indent">
            (2)　法令に従って要請された場合、又は法律手続上必要な場合、本規約を遵守していただくために必要な場合、第三者の権利の侵害に対するクレームに対応するために必要な場合、又はユーザ様の財産、権利、生命身体、業務等の安全や公共の福祉利益を守るために必要な場合などにおいて、当社が必要であると判断したときは、ユーザ様が本サービスで送受信したデータを保存し開示することができるものとします。
          </p>
          <p class="privacy_content-name">17. 本サービスの解約</p>
          <p class="indent">
            (1)　ユーザの皆様は、本サービスを任意に解約することができます。解約を希望するユーザ様は、当社又は代理店所定の書式により、当社又は代理店に対して本期間の満了日の2ヶ月前までに通知するものとします。ただし、本サービスの利用料金は、本期間の満了日まで発生し、解約日にかかわらず日割計算等による払戻はされません。
          </p>
          <p class="indent">
            (2)　当社は、本期間の満了日をもって、本サービスの提供を終了します。
          </p>
          <p class="privacy_content-name">18. 本サービスの停止及び本契約の解除</p>
          <p class="indent">
            (1)　当社は、合理的な理由に基づき必要と判断した場合、ID、パスワード等を削除し本サービスの利用を停止する権利、又は本契約を解除する権利を保有しています。この当社の権利は、ユーザ様が本契約又は本規約の内容又は趣旨に違背した、あるいは本契約又は本規約から見て不適切な行為を行ったと当社が判断した場合などにも行使されます。
          </p>
          <p class="indent">
            (2)　前項により当社が必要と判断し、特定のユーザ様に対して本サービスの提供を中止する場合、当社は、当該ユーザのID、パスワード等を無効とし、関連する情報や保存しているファイルを削除するとともに、当該ユーザが将来にわたって、本サービスにアクセスすることを禁止することができるものとします。この場合、当社及び代理店は本サービスの提供中止に関し、当該ユーザ及び第三者に対して一切責任を負わないものとします。上記いずれの場合にも当社は当該ユーザに対し、損害賠償等、新たな金銭的負担を負わないものとします。
          </p>
          <p class="privacy_content-name">19. 本サービスの継続と終了</p>
          <p class="indent">
            (1)　当社が本サービスに関連する事業を他の第三者に譲渡(合併、会社分割による場合を含みますがこれに限定されません)した場合、本規約に基づく権利及び義務、登録情報は、当該譲渡の譲受人に承継され、本サービスの提供は継続されるものとします。
          </p>
          <p class="indent">
            (2)　当社が本サービスを終了する場合、当社は、原則として2ヶ月前までにユーザの皆様に通知します。
          </p>
          <p class="privacy_content-name">20. 賠償責任の制限</p>
          <p class="indent">
            (1)　本サービスの提供の遅延又は不能によりユーザ様に損害が発生した場合でも、当社及び代理店は一切の損害賠償責任を負いません。ただし、当社の故意又は重過失に基づく場合は、この限りではありません。この場合、当社が賠償責任を負う損害の範囲は、ユーザ様が損害賠償を請求する1ヶ月前からユーザ様が当社に支払った本サービスの料金の総額を上限とし、かつ当社が賠償する損害の範囲は、当社の行為に基づき直接発生した損害に限られます。
          </p>
          <p class="indent">
            (2)　ユーザ様の本サービスのご利用状況、本サービスを通じて取引を行い入手した情報・商品の交換、もしくは役務を代替させるために要した費用、ユーザ様の送受信したデータへの不正アクセスや不正な改変、本サービスでの第三者による発言や送受信したデータ、その他サービスに関連する事項に起因又は関連して生じた一切の損害について、当社及び代理店は一切の賠償責任及び瑕疵担保責任を負いません。
          </p>
          <p class="privacy_content-name">21. 不可抗力</p>
          <p class="indent">
            当社は、戦争、紛争、革命、暴動、騒動、テロ行為、非常事態、伝染病、火事、水害、地震、天災、爆発、禁輸処置ほか政府機関の行為、インターネットの利用不能や不安定、大量のデータや不正パケットを送りつけるなどの不正な攻撃、その他当社の合理的管理を超える状況を原因とした不可抗力による不履行又は履行遅延について、一切の責任を負いません。
          </p>
          <p class="privacy_content-name">22. 非保障及び免責</p>
          <p class="indent">
            1. 当社は、本サービスおよび本アプリの性能について、その完全性、正確性、確実性、有用性等及び、特定の利用目的にかなうこと、第三者の権利を侵害するものについていかなる保証も行わないものとします。​
          </p>
          <p class="indent">
            2. 当社は、その過失の有無や過失の程度を問わず、次の各号に掲げるいずれかの事由によるもののほか、本商品に損害が生じた場合において、データ等の復旧、損害の賠償その他一切の責任を負わないものとします。
          </p>
          <p>
            (1) 弊社サーバー内のデータ等が滅失、損傷し、又は外部に漏れたこと。<br>
            (2) ユーザが弊社サーバーに接続することができず、又は弊社サーバーに接続するために通常より多くの時間を要したこと。 
          </p>
          <p class="indent">
            3.前項の規定にかかわらず当社及び代理店が損害賠償責任を負担する場合には、その賠償額は、その損害が生じた月において、当該個別契約にもとづきサービス利用料として当社若しくは代理店に対して支払った金額の範囲に制限されます。
          </p>
          <p class="indent">
            4.本商品の仕様について、顧客への提供品質に支障がない限りにおいて、当社の判断で変更できるものとします。また、本商品の変更点に関しては、変更前に説明を行うものとします。
          </p>
          <p class="privacy_content-name">23. 反社会的勢力の排除</p>
          <p class="indent">
            ユーザの皆様は、政府が発表している反社会的勢力による被害を防止するための指針(以下、「指針」という)を尊重し、本規約の同意をもって下記の各号に該当しないこと、及び今後もこれに該当する行為を行わないことを表明・保証するものとします。
          </p>
          <p>
            (1)　暴力団、暴力団構成員、暴力団関係企業もしくは関係者、総会屋、その他の反社会的勢力(以下、「反社会的勢力」という)であること、又は、反社会的勢力であったこと <br>
            (2)　役員又は実質的に経営を支配するものが反社会的勢力であること、又は、反社会的勢力であったこと <br>
            (3)　相手方に対して脅迫的な言動をとること、もしくは暴力を用いること、又は、相手方の名誉・信用を毀損する行為を行うこと <br>
            (4)　偽計又は威力を用いて相手方の業務を妨害すること <br>
            (5)　相手方に対し指針が排除の対象とする不当要求をすること <br>
            (6)　反社会的勢力である第三者をして前5号の行為を行わせること <br>
            (7)　自ら又はその役員もしくは実質的経営を支配するものが反社会的勢力への資金提供を行う等、その活動を助長する行為を行うこと <br>
          </p>
          <p class="indent">
            ユーザ様が当該表明・保証に違反した場合、当社は、本サービスの全て又は一部を何らかの催告をすることなく、中断又は中止することができます。
          </p>
          <p class="privacy_content-name">24. 本規約の変更</p>
          <p class="indent">
            当社は、ユーザの皆様からの同意を得ることなく、又は事前に通知することなく、当社の都合により本規約を変更することがあります。本規約の変更は、当社が改定後の本規約を「QuaLink」の公式サイト(https://qualink.jp/ 又はその継承もしくは代理Webサイト)に掲載した時点より効力が生じるものとします。ユーザの皆様は、定期的に本サイトを訪問し、最新の本規約をご確認ください。当社は、ユーザ様が本規約の変更後に本サービスをご利用されたことによって変更後の本規約を承諾したものとみなします。
          </p>
          <p class="privacy_content-name">25. 通知又は連絡</p>
          <p class="indent">
            当社からIDを登録されているユーザ様への通知又は連絡は、メールもしくは郵便を用いて行います。ユーザ様からの当社への通知又は連絡は、本サービス上に表示された該当窓口宛にメール、電話を用いて行うものとします。
          </p>
          <p class="privacy_content-name">26. 日本のユーザの皆様に適用される特則</p>
          <p class="indent">
            本規約の多言語版と日本語版の間に矛盾がある場合、日本語版が優先されます。
          </p>
          <p class="privacy_content-name">27. 準拠法及び管轄裁判所</p>
          <p class="indent">
            本サービス又は本規約に関連して当社とユーザ様の間に生じたあらゆる法律関係、及び本条項及び本条項の成立、効力、履行及び解釈についての準拠法は日本法とします。また、本サービス又は本規約に関連して当社とユーザ様の間で生じた紛争については、福岡地方裁判所ないし福岡簡易裁判所を専属的合意管轄裁判所とします。
          </p>
          <p class="privacy_content-name">28. その他</p>
          <p class="indent"> 
            ユーザの皆様が、本規約に違背するような行為等を発見された場合には当社までご連絡下さい。
          </p>
          <p class="indent">E-mail: info@itsumo-app.jp</p>
          <p class="privacy_content-date">
            最終改定日：<br />
            2023年4月25日
          </p>
          <p class="privacy_content-agree">
            内容に同意されましたら、<br />
            下記の「同意する」ボタンを押してください。
          </p>
        </div>
        <div class="tsunagaru_usage_read">
          <van-checkbox v-model="tsunagaru_usage_read_checked" style="margin-top: 10px;">次回から表示しない</van-checkbox>
        </div>
        <div
          @click="clickAgree"
          id="agree_btn"
          :class="{ possible: confirmDisable }"
        >
          同意する
        </div>
      </div>
    </div>
    <van-dialog
      v-model:show="showCodeErrorDialog"
      :message="codeErrorMsg"
      show-cancel-button
    >
    </van-dialog>
  </div>
</template>

<script>
  import {CheckCode, CheckLoginRequest, GetRefreshToken, Login} from "@/services/login";
  import {setAuthorization} from "@/utils/request";
  import {Toast} from "vant";
  import "vant/es/toast/style";
  import "vant/es/dialog/style";

  export default {
  components: {},
  data() {
    return {
      //user数据
      loginid: "",
      password: "",
      loading: false,
      //code错误与提示信息
      codeError: false,
      showCodeErrorDialog: false,
      codeErrorMsg: "番号が間違っています。URLを確認してください",
      pwdFlag: true,
      privacyPolicyShow: true,
      confirmDisable: false,
      code: "",
      login_request_interval:null,
      login_request_last:true,
      // 获取uuid用
      deviceFlg:false,
      deviceInterval:null,
      // 底部checkbox用
      tsunagaru_usage_read_checked:false,
    };
  },
  created() {},
  mounted() {
    this.errorLogOut();

    // const code = this.$route.query.code;
    let code = this.$route.query.code;
    if(typeof code==='undefined' || code==='' || code===null){
      code='12345'
    }
    if (code && code != "" && code != undefined) {
      CheckCode({ code: code }).then((res) => {
        if (res.data.code >= 0) {
          this.code = code;
          localStorage.removeItem(process.env.VUE_APP_CODE_KEY);
          localStorage.setItem(process.env.VUE_APP_CODE_KEY, this.code);
          this.codeError = false;
          this.showCodeErrorDialog = false;
        } else {
          this.codeError = true;
          this.showCodeErrorDialog = true;
        }
      });
    } else {
      this.codeError = true;
      this.showCodeErrorDialog = true;
    }
    const target = document.querySelector(".privacy_content");
    target.addEventListener("scroll", this.roll);

    let tsunagaru_usage_read = localStorage.getItem("tsunagaru_usage_read");
    console.log(tsunagaru_usage_read);
    if(tsunagaru_usage_read == 'true'){
      this.privacyPolicyShow = false;
    }

    this.adjustMarginTop();
    window.addEventListener('resize', this.adjustMarginTop);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.adjustMarginTop);
  },
  methods: {
    adjustMarginTop() {
      let height = window.innerHeight;
      let loginInputBox = this.$el.querySelector('.login_input-box');
      let loginIdPass = this.$el.querySelector('.login_id-pass');
      if (height < 500 ) {
        loginInputBox.style.marginTop = height / 10 + 'px';
        loginIdPass.style.padding = "0 17px 20px"
      } else {
        loginInputBox.style.marginTop = '155px';
        loginIdPass.style.padding = "0 17px 58px"
      }
    },
    async errorLogOut(){
      // 登录异常退出重新登录处理
      let num=0;
      this.deviceInterval = setInterval(async () => {
        num++
        if(num>10){
          if(this.deviceInterval){
            clearInterval(this.deviceInterval);
          }
          return;
        }
        // 只执行一次 且在获取到uuid后
        if(!this.deviceFlg && typeof device !== 'undefined' && device.uuid !== null && typeof device.uuid !== 'undefined'){
          if(this.deviceInterval){
            clearInterval(this.deviceInterval);
          }
          // 根据uuid获取状态
          let ret = await GetRefreshToken({ "uuid": device.uuid });
          // uuid有效
          if ( ret && ret.data && ret.data.data && ret.data.data.status && ret.data.data.status == 'effective') {
            localStorage.setItem("refreshtoken", ret.data.data.refreshtoken);
            localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(ret.data.data.user));
            let expireAt_T = ret.data.data.expireAt.replace(' ', 'T');
            setAuthorization({ token: ret.data.data.token, expireAt: new Date(expireAt_T) });
            window.location.reload();
          }
        }
      }, 500);
    },
    roll() {
      const target = document.querySelector(".privacy_content");
      var scroll_y = target.scrollHeight;
      var scroll_ny = target.offsetHeight;
      var scroll_p = target.scrollTop;
      if (scroll_y - scroll_p - scroll_ny < 1) {
        this.confirmDisable = true;
      }
    },
    onClickLogin() {
      if (this.codeError) {
        this.showCodeErrorDialog = true;
        return;
      }
      this.loading = true;
      this.showLoading();
      Login({
        loginid: this.loginid,
        password: this.password,
        code: this.code,
      }).then(this.afterLogin);
    },
    async afterLogin(res) {
      this.loading = false;
      this.$toast.clear();
      this.loginRes = {};
      const loginRes = res.data;
      if (loginRes.code >= 0) {
        // code == 1:二段验证
        if (loginRes.code === 1) {
          this.loginRes = loginRes;
          localStorage.setItem("loginAuthoritarian", JSON.stringify(loginRes));
          this.$router.push({path: "/verification",});
          this.$store.commit("setLoginid", this.loginid);
          this.$store.commit("setPassword", this.password);
          this.$store.commit("setCode", this.code);
        }else if (loginRes.code === 2) {
          // code == 2 帐号已经有人登录 请求登录
          Toast.loading({
            duration: 0,
            forbidClick: true,
          });
          this.login_request_interval = setInterval(()=>{this.applyLogin(loginRes);
          }, 1000);
        }else {
          this.toMain(loginRes);
        }
      } else {
        this.error = loginRes.message;
        Toast(this.error);
      }
    },
    async applyLogin(loginRes){
      if(!this.login_request_last){
        return;
      }
      this.login_request_last = false;
      let ret = loginRes.data;
      // 发送请求验证对方是否同意请求
      let res =  await CheckLoginRequest({status:"apply",id:ret.id,uid:ret.uid});
      if(res.data.code >= 0){
        let result = res.data.data;
        if(result.status == 'outTime'){
          // 本次申请已经超时
          this.clearLoading();
          Toast.fail(result.message);
        }else if(result.status == 'agree'){
          // 同意
          this.clearLoading();
          this.onClickLogin();
        }else if(result.status == 'refuse') {
          // 拒绝
          this.clearLoading();
          Toast.fail(result.message);
        }else if(result.status == 'exist') {
          // 有其他用户在登录
          this.clearLoading();
          Toast.fail(result.message);
        }
      }else{
        Toast("error");
      }
      this.login_request_last = true;
    },
    clearLoading(){
      clearInterval(this.login_request_interval);
      this.login_request_interval = null;
      Toast.clear();
    },
    toMain(data) {
      //用户名密码验证通过之后，保存用户信息 跳转主页
      const { user, refreshToken, token, expireAt } = data.data;
      localStorage.setItem("refreshtoken", refreshToken);
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
      //解决ipad 登录问题
      let expireAt_T = expireAt.replace(' ', 'T');

      setAuthorization({ token: token, expireAt: new Date(expireAt_T) });

      // 检查 sessionStorage 中是否有会议URL
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      console.log("--------"+redirectUrl+"--------")

      if (redirectUrl) {
        // 如果有，重定向到这个URL，并删除 sessionStorage 中的记录
        this.$router.push(redirectUrl);
        sessionStorage.removeItem('redirectUrl');
      } else {
        // 如果没有，那么进行默认的页面刷新操作
        window.location.reload();
      }
    },
    showLoading() {
      this.$toast.loading({
        mask: true,
        message: "",
      });
    },
    changePwd() {
      this.pwdFlag = !this.pwdFlag;
    },
    clickAgree() {
      this.privacyPolicyShow = false;
      if(this.tsunagaru_usage_read_checked){
        localStorage.setItem("tsunagaru_usage_read",true);
      }
    },
    openAgree() {
      this.privacyPolicyShow = true;
    },
    openForgotPwd() {
      this.$router.push({
        path: "/verifyUserLoginId",
        query: { code: this.code },
      });
    },
  },

  watch: {},
};
</script>

<style scoped>
#login1_btn {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
.img-opacity {
  opacity: 0.4;
}
#name:focus,
#password:focus {
  border: 2px solid #e59700;
}
.indent {
  text-indent: 1em;
}
.tsunagaru_usage_read{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>